"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var TableActionConfirm_1 = require("../../../../../../shared/components/table_actions/TableActionConfirm");
var TableActionReject_1 = require("../../../../../../shared/components/table_actions/TableActionReject");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var TableActionLockLock_1 = require("../../../../../../shared/components/table_actions/TableActionLockLock");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var TableActionComment_1 = require("../../../../../../shared/components/table_actions/TableActionComment");
var WithdrawReqDetailExpander_1 = require("./expander/WithdrawReqDetailExpander");
var FinanceWithdrawRequestsList = /** @class */ (function (_super) {
    __extends(FinanceWithdrawRequestsList, _super);
    function FinanceWithdrawRequestsList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Дата',
                dataIndex: _this.props.data.dk_date_added,
                key: _this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 250
            }, {
                title: 'Игрок/Партнер',
                dataIndex: _this.props.data.dk_player_login,
                key: _this.props.data.dk_player_login,
                width: 150,
                render: function (text, record, idx) {
                    if (record.partner_id > 0) {
                        return (React.createElement("div", null,
                            " ",
                            React.createElement(FontAwesome_1.FA, { left: true, icon: "user-tie" }),
                            "  ",
                            record.partner_login,
                            " "));
                    }
                    else {
                        if (record.is_suspicious) {
                            return (React.createElement("div", { style: _this.getCssStyle(record) },
                                "  ",
                                React.createElement(FontAwesome_1.FA, { left: true, icon: "user" }),
                                " ",
                                record.player_login,
                                " ",
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "exclamation-triangle" }),
                                "  "));
                        }
                        else {
                            return (React.createElement("div", { style: _this.getCssStyle(record) },
                                "  ",
                                React.createElement(FontAwesome_1.FA, { left: true, icon: "user" }),
                                " ",
                                record.player_login,
                                " "));
                        }
                    }
                }
            }, {
                title: 'EMail',
                dataIndex: _this.props.data.dk_player_email,
                key: _this.props.data.dk_player_email,
                width: 150,
                render: function (text, record, idx) {
                    if (record.partner_id > 0) {
                        return (React.createElement("div", null,
                            " ",
                            React.createElement(FontAwesome_1.FA, { left: true, icon: "user-tie" }),
                            "  ",
                            record.partner_email,
                            " "));
                    }
                    else {
                        return (React.createElement("div", null,
                            "  ",
                            React.createElement(FontAwesome_1.FA, { left: true, icon: "user" }),
                            " ",
                            record.player_email,
                            " "));
                    }
                }
            }, {
                title: 'Баланс (Д/П/Б)',
                dataIndex: _this.props.data.dk_money_balance,
                key: _this.props.data.dk_money_balance,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        UIUtils_1.UIUtils.formatCurrency(record.money_balance),
                        "/",
                        UIUtils_1.UIUtils.formatCurrency(record.points_balance),
                        "/",
                        UIUtils_1.UIUtils.formatCurrency(record.bonus_balance)));
                },
                width: 150,
            }, {
                title: 'Тип',
                dataIndex: _this.props.data.dk_withdraw_type_title,
                key: _this.props.data.dk_withdraw_type_title,
                width: 200,
            }, {
                title: 'Основание',
                dataIndex: _this.props.data.dk_withdraw_basis_title,
                key: _this.props.data.dk_withdraw_basis_title,
                width: 200,
            }, {
                title: 'Сумма',
                dataIndex: _this.props.data.dk_amount_in_withdraw_currency_without_comission,
                key: _this.props.data.dk_amount_in_withdraw_currency_without_comission,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        UIUtils_1.UIUtils.formatCurrency(record.amount_in_player_currency_without_comission),
                        " ",
                        record.withdraw_currency_title));
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null, _this.getActionButtons(record))); },
                width: 110
            }, {
                title: 'Бренд',
                dataIndex: _this.props.data.dk_brand_title,
                key: _this.props.data.dk_brand_title,
                width: 150,
            }
        ];
        return _this;
    }
    FinanceWithdrawRequestsList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    FinanceWithdrawRequestsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    FinanceWithdrawRequestsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    FinanceWithdrawRequestsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    FinanceWithdrawRequestsList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadRangeDataByBrandsList({
            brands: this.props.brandsList,
            allBrands: this.props.allBrands,
            Limit: this.state.pageSize,
            Offset: this.getDataOffset(),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    FinanceWithdrawRequestsList.prototype.onConfirmClick = function (record) {
        var _this = this;
        this.props.data.DoConfirmWithdrawal(record.key, function () {
            _this.loadData(_this.props, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ",
                    React.createElement("b", null,
                        "[",
                        record.key,
                        "]"),
                    " \u0431\u044B\u043B\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u0430 \u043D\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435"));
            });
        });
    };
    FinanceWithdrawRequestsList.prototype.onRejectClick = function (record) {
        var _this = this;
        this.props.data.DoRejectWithdrawal(record.key, function () {
            _this.loadData(_this.props, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ",
                    React.createElement("b", null,
                        "[",
                        record.key,
                        "]"),
                    " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430"));
            });
        });
    };
    FinanceWithdrawRequestsList.prototype.onSendMessageClick = function (record) {
        //this.props.data.DoRejectWithdrawal(record.key, () => {
        //    this.loadData(this.props, () => {
        //        notificationHelper.ShowTopRightNotification(<div>Заявка на выплату <b>[{record.key}]</b> была успешно отменена</div>);
        //    })
        //})
        var _this = this;
        this.props.dlgMessage.clearFields().SetDialogTitle("Новое сообщение игроку")
            .SetMessageBody("")
            .SetMessageTitle("")
            .SetOnYesClick(function (messageTitle, messageBody /*, isHasPromo, promoCode, isImportant*/) {
            _this.props.data.doSendMessage({
                message: messageBody,
                title: messageTitle,
                usr_player_id: record.player_id,
            }, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u0443 ",
                    React.createElement("b", null,
                        "[",
                        record.player_login,
                        "]"),
                    " \u0441\u043E\u0437\u0434\u0430\u043D\u043E !"));
            });
        }).Show();
    };
    FinanceWithdrawRequestsList.prototype.getCssStyle = function (rec) {
        var _ret = {
            textDecoration: "line-through",
            color: "#FF0000"
        };
        var _retNone = {};
        if (rec.partner_id == 0) {
            if (rec.player_is_locked) {
                return _ret;
            }
            if (rec.is_suspicious) {
                return _ret;
            }
        }
        return _retNone;
    };
    FinanceWithdrawRequestsList.prototype.getActionButtons = function (record) {
        var _this = this;
        var _ret = [];
        if (!record.is_pending) {
            _ret.push(React.createElement(TableActionConfirm_1.default, { hint: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C", confirmText: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ?", onClick: function () { _this.onConfirmClick(record); }, key: "ab_1" }));
            _ret.push(React.createElement(TableActionReject_1.default, { hint: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C", confirmText: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ?", onClick: function () { _this.onRejectClick(record); }, key: "ab_2" }));
            _ret.push(React.createElement(TableActionComment_1.default, { hint: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0443", onClick: function () { _this.onSendMessageClick(record); }, key: "ab_3" }));
        }
        else {
            _ret.push(React.createElement(TableActionLockLock_1.default, { disabled: true, confirmText: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u0443 ?", onClick: function () { }, key: "al_1" }));
        }
        return _ret;
    };
    FinanceWithdrawRequestsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    FinanceWithdrawRequestsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
    };
    FinanceWithdrawRequestsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    FinanceWithdrawRequestsList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    FinanceWithdrawRequestsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement(WithdrawReqDetailExpander_1.default, { data: record, state: _this.props.state })
                    /*<div>
                        <div><b>Идентификатор записи:</b> [{record.key}] </div>
                        <div><b>Создан:</b> [{record.date_added.format(this.state.dtFormat)}] </div>
                        <div><b>Изменен:</b> [{record.date_changed.format(this.state.dtFormat)}]</div>
                        <div><b>Комментарий:</b> [{record.description}]</div>
                        <div><b>Баланс до:</b> [{record.player_balance_before}]</div>
                        <div><b>Баланс после:</b> [{record.player_balance_after}]</div>
                        <div><b>Комментарий:</b> [{record.description}]</div>
                        <div><b>Курс обмена (снятие игрок):</b> [{record.exchange_rate_withdraw_to_player}]</div>
                        <div><b>Запрос:</b> [{record.withdraw_req}]</div>
                        <div><b>Ответ:</b> [{record.withdraw_resp}]</div>
                        <div><b>Данные для выплаты:</b> [{record.withdraw_data}]</div>
                    </div>*/
                    );
                }, scroll: { x: true } })));
    };
    return FinanceWithdrawRequestsList;
}(React.Component));
exports.default = FinanceWithdrawRequestsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_withdraw_requests_list/ui/component/FinanceWithdrawRequestsList.tsx
// module id = 2446
// module chunks = 0